var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.857,
    height: 19.852,
    viewBox: "0 0 19.857 19.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.566,21.215l7.092-7.092a1.662,1.662,0,0,0-2.35-2.35l-7.092,7.092-7.092-7.092a1.662,1.662,0,1,0-2.35,2.35l7.092,7.092-7.092,7.092a1.662,1.662,0,0,0,2.35,2.35l7.092-7.092,7.092,7.092a1.662,1.662,0,0,0,2.35-2.35Z",
    transform: "translate(-11.285 -11.289)",
    fill: "#e61119"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/icon-cross.ee5f3549b1770810ceb0f9c4ab75c662.svg";
export { ForwardRef as ReactComponent };